import React from "react";
import { assets } from "../../Assets/assets";
import { icons } from "../../Assets/Icons/icons";
import { useNavigate } from "react-router-dom";

const TopNavBar = ({
  setMenuOpen,
  setActiveDropdown,
  menuOpen,
  activeDropdown,
}) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
    setActiveDropdown(null);
    window.scrollTo(0, 0);
  };

  return (
    <nav className="hidden lg:flex items-center gap-5 justify-center lg:justify-between xl:px-20 px-6">
      <div
        className="flex items-center justify-center cursor-pointer"
        onClick={() => handleNavigate("/")}
      >
        <figure className="xl:h-16 xl:w-20 h-14 w-16">
          <img
            className="h-full w-full object-contain"
            src={assets.navLogo}
            alt="nav-logo"
          />
        </figure>
        <h1 className="text-primaryTextColor w-fit font-bold font-smooch leading-6 text-2xl xl:text-3xl">
          SEKHAR <br /> BUILDERS
        </h1>
      </div>
      <ul className="flex space-x-10 items-center">
        <li>
          <div className="flex items-center gap-2">
            <span className="xl:text-3xl text-2xl bg-[#F8F7F3] text-gray-600 p-3 rounded-full">
              {icons.phoneIcon}
            </span>
            <div>
              <p className="text-gray-500 text-sm">Have any Question?</p>
              <h1 className="xl:text-xl text-lg font-semibold">
                +91 9437062040, 9438299105
              </h1>
            </div>
          </div>
        </li>
        <li>
          <div className="flex items-center gap-2">
            <span className="xl:text-3xl text-2xl bg-[#F8F7F3] text-gray-600 p-3 rounded-full">
              {icons.mailIcon}
            </span>
            <div>
              <p className="text-gray-500 text-sm">Email Us:?</p>
              <a
                href="mailto:sekharbuilders@gmail.com
"
                className="xl:text-xl text-lg font-semibold hover:text-[#E4E95B] transition-colors duration-300"
              >
                sekharbuilders@gmail.com
              </a>
            </div>
          </div>
        </li>
      </ul>
      {/* <ul className="hidden lg:flex space-x-7">
        <li>
          <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
            {icons.facebookIcon}
          </span>
        </li>
        <li>
          <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
            {icons.twitterIcon}
          </span>
        </li>
        <li>
          <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
            {icons.instagramIcon}
          </span>
        </li>
        <li>
          <span className="xl:text-3xl text-2xl hover:text-[#E4E95B] transition-colors duration-300 cursor-pointer text-gray-600">
            {icons.youtubeIcon}
          </span>
        </li>
      </ul> */}
    </nav>
  );
};

export default TopNavBar;
